export interface IPublicUserData {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  gender: number;
  age: number;
  isGlobal: boolean;
  isRegistered: boolean;
  isConfirmed: boolean;
  createdAt: Date;
  isBanned?: boolean;
}
